module.exports = __webpack_public_path__ + "515f39c0f759a908166fc3b4105fa793.svg";